import {ProductInterface} from "../../interfaces/product/ProductInterface";

export default function Reviews() {
    return (<div className="flex-column flex-lg-row gap-4  justify-content-between prod-pane" >

        <div className="prod-rev">
            <div className="fw-bold prod-rev__title">
                Отзывы о товаре
            </div>
            <div className="prod-rev__slider">
                <div className="swiper-wrapper">
                    <div className="swiper-slide prod-rev__slide">
                        <picture>
                            <source srcSet="images/prod-reviews-img.webp" type="image/webp"/>
                            <img src="images/prod-reviews-img.jpg" alt=""/></picture>
                    </div>
                    <div className="swiper-slide prod-rev__slide">
                        <picture>
                            <source srcSet="images/prod-reviews-img.webp" type="image/webp"/>
                            <img src="images/prod-reviews-img.jpg" alt=""/></picture>
                    </div>
                    <div className="swiper-slide prod-rev__slide">
                        <picture>
                            <source srcSet="images/prod-reviews-img.webp" type="image/webp"/>
                            <img src="images/prod-reviews-img.jpg" alt=""/></picture>
                    </div>
                    <div className="swiper-slide prod-rev__slide">
                        <picture>
                            <source srcSet="images/prod-reviews-img.webp" type="image/webp"/>
                            <img src="images/prod-reviews-img.jpg" alt=""/></picture>
                    </div>
                    <div className="swiper-slide prod-rev__slide">
                        <picture>
                            <source srcSet="images/prod-reviews-img.webp" type="image/webp"/>
                            <img src="images/prod-reviews-img.jpg" alt=""/></picture>
                    </div>
                    <div className="swiper-slide prod-rev__slide">
                        <picture>
                            <source srcSet="images/prod-reviews-img.webp" type="image/webp"/>
                            <img src="images/prod-reviews-img.jpg" alt=""/></picture>
                    </div>
                    <div className="swiper-slide prod-rev__slide">
                        <picture>
                            <source srcSet="images/prod-reviews-img.webp" type="image/webp"/>
                            <img src="images/prod-reviews-img.jpg" alt=""/></picture>
                    </div>
                    <div className="swiper-slide prod-rev__slide">
                        <picture>
                            <source srcSet="images/prod-reviews-img.webp" type="image/webp"/>
                            <img src="images/prod-reviews-img.jpg" alt=""/></picture>
                    </div>
                </div>
            </div>
            <div className="d-flex flex-column flex-md-row prod-rev__content">
                <div className="d-flex flex-md-column prod-rev__left rev-left">
                    <div className="fw-bold rev-left__number">
                        4.6
                    </div>
                    <div className="d-flex align-items-center justify-content-between rev-left__estim">
                        <div className="d-flex rev-left__star">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#DADCDE"/>
                                <path
                                    d="M8.55859 1.21289V13.9258L8.49902 13.8945L3.39551 16.6025L4.33301 10.9775L0.558594 7.29688V6.85742L5.89551 6.08203L8.39551 0.874023L8.55859 1.21289Z"
                                    fill="#FC5521"/>
                            </svg>
                        </div>
                        <p>
                            13 отзывов
                        </p>
                    </div>
                    <a href="#" className="btn btn-primary big w-100">
                        Написать отзыв
                    </a>

                    <div
                        className="align-items-center justify-content-between rev-left__estim d-md-flex d-none">
                        <div className="d-flex rev-left__star">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                        </div>
                        <p>
                            11 отзывов
                        </p>
                    </div>
                    <div
                        className="align-items-center justify-content-between rev-left__estim d-md-flex d-none">
                        <div className="d-flex rev-left__star">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.016L8.49935 13.3077L3.39518 16.016L4.33268 10.391L0.166016 6.32853L5.89518 5.4952L8.39518 0.286865L10.8952 5.4952L16.6243 6.32853L12.666 10.391L13.6035 16.016Z"
                                    fill="#DADCDE"/>
                            </svg>
                        </div>
                        <p>
                            1 отзыв
                        </p>
                    </div>
                    <div
                        className="align-items-center justify-content-between rev-left__estim d-md-flex d-none">
                        <div className="d-flex rev-left__star">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                    fill="#FC5521"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.016L8.49935 13.3077L3.39518 16.016L4.33268 10.391L0.166016 6.32853L5.89518 5.4952L8.39518 0.286865L10.8952 5.4952L16.6243 6.32853L12.666 10.391L13.6035 16.016Z"
                                    fill="#DADCDE"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.016L8.49935 13.3077L3.39518 16.016L4.33268 10.391L0.166016 6.32853L5.89518 5.4952L8.39518 0.286865L10.8952 5.4952L16.6243 6.32853L12.666 10.391L13.6035 16.016Z"
                                    fill="#DADCDE"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.016L8.49935 13.3077L3.39518 16.016L4.33268 10.391L0.166016 6.32853L5.89518 5.4952L8.39518 0.286865L10.8952 5.4952L16.6243 6.32853L12.666 10.391L13.6035 16.016Z"
                                    fill="#DADCDE"/>
                            </svg>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.6035 16.016L8.49935 13.3077L3.39518 16.016L4.33268 10.391L0.166016 6.32853L5.89518 5.4952L8.39518 0.286865L10.8952 5.4952L16.6243 6.32853L12.666 10.391L13.6035 16.016Z"
                                    fill="#DADCDE"/>
                            </svg>
                        </div>
                        <p>
                            1 отзыв
                        </p>
                    </div>
                </div>
                <div className="d-flex flex-column prod-rev__right rev-right">
                    <div className="d-flex align-items-center rev-right__head">
                        <div className="d-flex">
                            <p>Сортировать по:</p>
                            <p className="prod-rev-sort-item">Оценке</p>
                            <p className="active prod-rev-sort-item">Дате</p>
                            <p className="prod-rev-sort-item">Полезности</p>
                        </div>
                        <div className="d-flex align-items-center rev-right__est-choice">
                            <p>Оценка</p>
                            <div className="dropdown">
                                <button className="btn gray dropdown-toggle" type="button"
                                        id="dropdownProdChoice"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                    Любая
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownProdChoice">
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            5 звезд
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            4 звезды
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            3 звезды
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            2 звезда
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            1 звезда
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column rev-right__body">
                        <div className="rev-right__t-box">
                            <div className="d-flex flex-md-column rev-right__acount">
                                <div className="d-flex rev-left__star">
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.6035 16.6032L8.49935 13.8949L3.39518 16.6032L4.33268 10.9782L0.166016 6.91569L5.89518 6.08236L8.39518 0.874023L10.8952 6.08236L16.6243 6.91569L12.666 10.9782L13.6035 16.6032Z"
                                            fill="#FC5521"/>
                                    </svg>
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.6035 16.016L8.49935 13.3077L3.39518 16.016L4.33268 10.391L0.166016 6.32853L5.89518 5.4952L8.39518 0.286865L10.8952 5.4952L16.6243 6.32853L12.666 10.391L13.6035 16.016Z"
                                            fill="#DADCDE"/>
                                    </svg>
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.6035 16.016L8.49935 13.3077L3.39518 16.016L4.33268 10.391L0.166016 6.32853L5.89518 5.4952L8.39518 0.286865L10.8952 5.4952L16.6243 6.32853L12.666 10.391L13.6035 16.016Z"
                                            fill="#DADCDE"/>
                                    </svg>
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.6035 16.016L8.49935 13.3077L3.39518 16.016L4.33268 10.391L0.166016 6.32853L5.89518 5.4952L8.39518 0.286865L10.8952 5.4952L16.6243 6.32853L12.666 10.391L13.6035 16.016Z"
                                            fill="#DADCDE"/>
                                    </svg>
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.6035 16.016L8.49935 13.3077L3.39518 16.016L4.33268 10.391L0.166016 6.32853L5.89518 5.4952L8.39518 0.286865L10.8952 5.4952L16.6243 6.32853L12.666 10.391L13.6035 16.016Z"
                                            fill="#DADCDE"/>
                                    </svg>
                                </div>
                                <div className="d-flex align-items-center rev-right__acount-text">
                                    <p className="fw-bold">Алексей</p>
                                    <p>15.03.2025</p>
                                    <p>г. Москва</p>
                                </div>
                            </div>


                        </div>
                        <div className="rev-right__t-box">
                            <div className="rev-right__row-lines">
                                <div className="rev-right__item-line">
                                    <div className="d-flex justify-content-between">
                                        <p>Качество аккумулятора</p>
                                        <p>4.9</p>
                                    </div>
                                    <div className="line-body">
                                        <div className="line" style={{width: '97%'}}></div>
                                    </div>
                                </div>
                                <div className="rev-right__item-line">
                                    <div className="d-flex justify-content-between">
                                        <p>Удобство работы</p>
                                        <p>4.9</p>
                                    </div>
                                    <div className="line-body">
                                        <div className="line" style={{width: '97%'}}></div>
                                    </div>
                                </div>
                                <div className="rev-right__item-line">
                                    <div className="d-flex justify-content-between">
                                        <p>Качество зарядки</p>
                                        <p>4.9</p>
                                    </div>
                                    <div className="line-body">
                                        <div className="line" style={{width: '97%'}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex flex-column rev-right__t-box">
                            <p className="fw-bold">Достоинства</p>
                            <p>Всего один режим. Без мигалок и прочих переключений. Настоящий правильный
                                фонарь.</p>
                        </div>
                        <div className="d-flex flex-column rev-right__t-box">
                            <p className="fw-bold">Недостатки</p>
                            <p>Никаких. Все устраивает.</p>
                        </div>
                        <div className="d-flex flex-column rev-right__t-box">
                            <p className="fw-bold">Комментарий</p>
                            <p>Хороший ровный круг света, по краям рассеянный. Цвет свечения не
                                ядовитый, но холодный. Один
                                режим. Сделан аккуратно.</p>
                        </div>
                        <div
                            className="d-flex align-items-center justify-content-between rev-right__bot-box">
                            <a className="rev-right__btn-ans" href="#">Ответить</a>
                            <div className="d-flex rev-right__like-row">
                                <div className="d-flex align-items-center rev-right__like">
                                    <svg width="22" height="23" viewBox="0 0 22 23" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.41732 20.5946V10.5112M1.83398 12.3446V18.7612C1.83398 19.7738 2.6548 20.5946 3.66732 20.5946H15.9747C17.332 20.5946 18.4863 19.6043 18.6927 18.2627L19.6799 11.8461C19.9362 10.1802 18.6473 8.6779 16.9619 8.6779H13.7507C13.2444 8.6779 12.834 8.26749 12.834 7.76123V4.52158C12.834 3.27322 11.822 2.26123 10.5736 2.26123C10.2759 2.26123 10.006 2.43658 9.88512 2.70868L6.65926 9.96686C6.51214 10.2979 6.18386 10.5112 5.8216 10.5112H3.66732C2.6548 10.5112 1.83398 11.332 1.83398 12.3446Z"
                                            stroke="#626262" stroke-width="1.83333"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"/>
                                    </svg>
                                    <span>0</span>
                                </div>
                                <div className="d-flex align-items-center rev-right__like">
                                    <svg width="22" height="23" viewBox="0 0 22 23" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.4167 2.26123V12.3446M1.83337 9.41123V5.19456C1.83337 4.1678 1.83337 3.65442 2.03319 3.26225C2.20896 2.91728 2.48942 2.63682 2.83438 2.46105C3.22656 2.26123 3.73994 2.26123 4.7667 2.26123H14.5585C15.8982 2.26123 16.5681 2.26123 17.1091 2.50638C17.5859 2.72244 17.9912 3.07012 18.2772 3.50855C18.6018 4.00601 18.7036 4.66806 18.9074 5.99218L19.3868 9.10884C19.6555 10.8553 19.7899 11.7285 19.5307 12.4079C19.3033 13.0043 18.8754 13.5029 18.3206 13.8184C17.6885 14.1779 16.805 14.1779 15.038 14.1779H14.3C13.7867 14.1779 13.53 14.1779 13.3339 14.2778C13.1614 14.3657 13.0212 14.5059 12.9333 14.6784C12.8334 14.8745 12.8334 15.1312 12.8334 15.6446V18.3342C12.8334 19.5826 11.8214 20.5946 10.573 20.5946C10.2753 20.5946 10.0054 20.4192 9.8845 20.1471L6.80381 13.2156C6.66369 12.9003 6.59363 12.7427 6.48289 12.6271C6.385 12.5249 6.26479 12.4468 6.13166 12.3988C5.98106 12.3446 5.80856 12.3446 5.46355 12.3446H4.7667C3.73994 12.3446 3.22656 12.3446 2.83438 12.1447C2.48942 11.969 2.20896 11.6885 2.03319 11.3435C1.83337 10.9514 1.83337 10.438 1.83337 9.41123Z"
                                            stroke="#626262" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round"/>
                                    </svg>
                                    <span>0</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-md-center rev-right__bot">
                        <a href="$" className="d-flex align-items-center fw-semibold rev-right__all">
                            <span>Посмотреть все отзывы</span>
                            <svg width="9" height="16" viewBox="0 0 9 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16553 1.30273L7.98723 8.12444L1.16553 14.9461"
                                      stroke="#1A171B"
                                      stroke-width="1.70543" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>)
}